import angular from 'angular';
import {LoggerConfig} from './logger-config';
import {ManagerGlobalStateModule} from '../global-state/global-state.module';

// Comments and information are in the config file.
export const LoggerModule = angular.module('buildium.logger', [
    ManagerGlobalStateModule.name
])
    .config(LoggerConfig);
